import { useState } from 'react'

import PropTypes from 'prop-types'
import { Box, Button, Hidden, Typography } from '@material-ui/core'

import { Card } from 'components'
import { DialogOutsourcedDpo } from './components'

const InviteAdvisor = ({
  refresh,
  company,
  invite,
  isEdit,
  advisorData,
  setAdvisorData,
  dpoType,
}) => {
  const [openDialog, setOpenDialog] = useState(false)

  const inviteTypeText = {
    observer: 'DPO Observador',
    responsible: 'DPO Responsável',
  }[dpoType]

  const handleChangeDeleteOrOpenDialog = () => {
    if (advisorData) {
      setAdvisorData(null)
    } else {
      setOpenDialog(true)
    }
  }

  const handleOpenDialog = () => {
    setOpenDialog(true)
  }

  const inviteText = () => {
    const statusesMessages = {
      PENDING: (
        <>
          &nbsp;está com o convite pendente para se tornar&nbsp;
          <Typography component="span" fontWeight="bold">
            {inviteTypeText}
          </Typography>
          .
        </>
      ),
      REFUSED: (
        <>
          &nbsp;recusou o convite para se tornar&nbsp;
          <Typography component="span" fontWeight="bold">
            {inviteTypeText}
          </Typography>
          .
        </>
      ),
      CANCELED: <>&nbsp;está com o vínculo cancelado.</>,
      ACTIVE: (
        <>
          &nbsp;está registrado como o&nbsp;
          <Typography component="span" fontWeight="bold">
            {inviteTypeText}
          </Typography>
          &nbsp; dessa empresa.
        </>
      ),
    }

    if (!invite && isEdit)
      return (
        <Typography variant="body1">
          Essa empresa não possui um&nbsp;
          <Typography component="span" fontWeight="bold">
            {inviteTypeText}
          </Typography>
          &nbsp; registrado
        </Typography>
      )
    else if (!isEdit && !advisorData) {
      return (
        <Typography variant="body1">
          Essa empresa não possui um&nbsp;
          <Typography component="span" fontWeight="bold">
            {inviteTypeText}
          </Typography>
          &nbsp; registrado
        </Typography>
      )
    } else if (!isEdit && advisorData) {
      return (
        <Typography variant="body1">
          {advisorData?.email} será adicionado como&nbsp;
          <Typography component="span" fontWeight="bold">
            {inviteTypeText}
          </Typography>
          &nbsp; nessa empresa
        </Typography>
      )
    }

    return (
      <>
        <strong>{invite?.name || invite?.email}</strong>
        &nbsp;
        {statusesMessages[invite.status]}
      </>
    )
  }

  return (
    <Box mt={4}>
      <Card title={inviteTypeText} paddingBottom={0}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="body1" color="textPrimary">
            {inviteText()}
          </Typography>
          {isEdit ? (
            <Button
              variant="contained"
              color="primary"
              onClick={handleOpenDialog}
            >
              {invite ? 'VISUALIZAR' : 'ADICIONAR'}&nbsp;
              <Hidden xsDown>{inviteTypeText}</Hidden>
            </Button>
          ) : (
            <Button
              variant="contained"
              color={advisorData ? 'secondary' : 'primary'}
              onClick={handleChangeDeleteOrOpenDialog}
            >
              {advisorData ? 'EXCLUIR' : 'ADICIONAR'}&nbsp;
              <Hidden xsDown>{inviteTypeText}</Hidden>
            </Button>
          )}
        </Box>
      </Card>
      <DialogOutsourcedDpo
        refresh={refresh}
        open={openDialog}
        setOpen={setOpenDialog}
        invite={invite}
        company={company}
        dpoType={dpoType}
        inviteTypeText={inviteTypeText}
        isEdit={isEdit}
        setAdvisorData={setAdvisorData}
      />
    </Box>
  )
}

InviteAdvisor.propTypes = {
  refresh: PropTypes.func,
  company: PropTypes.object,
  invite: PropTypes.string,
  isEdit: PropTypes.bool,
  advisorData: PropTypes.object,
  setAdvisorData: PropTypes.func,
  dpoType: PropTypes.string,
}

export default InviteAdvisor
